import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { RotaProtegida } from './components/auth/RotaProtegida';
import { LoginPage } from './pages/auth/LoginPage';
import { CadastroPage } from './pages/auth/CadastroPage';
import { RecuperarSenhaPage } from './pages/auth/RecuperarSenhaPage';
import { CompletarCadastroPage } from './pages/cidadao/CompletarCadastroPage';
import { InicioGate } from './pages/cidadao/InicioGate';
import { PerfilPage } from './pages/cidadao/PerfilPage';
import { CartaServicosPage } from './pages/cidadao/CartaServicosPage';
import { ServicoDetalhePage } from './pages/cidadao/ServicoDetalhePage';
import { SolicitarPage } from './pages/cidadao/SolicitarPage';
import { MinhasSolicitacoesPage } from './pages/cidadao/MinhasSolicitacoesPage';
import { ProcessosParticipoPage } from './pages/cidadao/ProcessosParticipoPage';
import { FornecedorOrdensPage } from './pages/cidadao/FornecedorOrdensPage';
import { FornecedorOrdemDetalhePage } from './pages/cidadao/FornecedorOrdemDetalhePage';
import { NotificacoesPage } from './pages/cidadao/NotificacoesPage';
import { EnquetesPage } from './pages/cidadao/EnquetesPage';
import { ConselhoPage } from './pages/cidadao/ConselhoPage';
import { SolicitacaoDetailPage } from './pages/cidadao/SolicitacaoDetailPage';
import { OuvidoriaPage } from './pages/cidadao/OuvidoriaPage';
import { EsicAbrirPage } from './pages/cidadao/EsicAbrirPage';
import { EsicRecorrerPage } from './pages/cidadao/EsicRecorrerPage';
import { RecursoTransitoAbrirPage } from './pages/cidadao/RecursoTransitoAbrirPage';
import { RecursoTransitoCetranPage } from './pages/cidadao/RecursoTransitoCetranPage';
import { PssListPublicoPage } from './pages/publico/PssListPublicoPage';
import { PssEditalDetalhePage } from './pages/publico/PssEditalDetalhePage';
import { PssInscreverPage } from './pages/cidadao/PssInscreverPage';
import { PssMinhasInscricoesPage } from './pages/cidadao/PssMinhasInscricoesPage';
import { AprovacaoProjetosSubmeterPage } from './pages/cidadao/AprovacaoProjetosSubmeterPage';
import { AcompanharProtocoloPublicoPage } from './pages/publico/AcompanharProtocoloPublicoPage';
import { OuvidoriaAvaliarPage } from './pages/publico/OuvidoriaAvaliarPage';
import { OuvidoriaMapaPage } from './pages/publico/OuvidoriaMapaPage';
import { MapaPublicoPage } from './pages/publico/MapaPublicoPage';
import { OuvidoriaIndicadoresPage } from './pages/publico/OuvidoriaIndicadoresPage';
import { EsicTransparenciaPage } from './pages/publico/EsicTransparenciaPage';
import { CanaisAtendimentoPage } from './pages/publico/CanaisAtendimentoPage';
import { ServicosEmbedPage } from './pages/publico/ServicosEmbedPage';
import { AtosOficiaisPublicoPage } from './pages/publico/AtosOficiaisPublicoPage';
import { AtoOficialDetalhePublicoPage } from './pages/publico/AtoOficialDetalhePublicoPage';
import { ProtocoloLegislativoPublicoPage } from './pages/publico/ProtocoloLegislativoPublicoPage';
import { ProtocoloLegislativoDetalhePublicoPage } from './pages/publico/ProtocoloLegislativoDetalhePublicoPage';
import { ZeladoriaAbrirPage } from './pages/cidadao/ZeladoriaAbrirPage';
import { ZeladoriaMapaPage } from './pages/publico/ZeladoriaMapaPage';
import { ZeladoriaIndicadoresPage } from './pages/publico/ZeladoriaIndicadoresPage';
import { DiarioOficialPublicoPage } from './pages/publico/DiarioOficialPublicoPage';
import { DiarioOficialDetalhePublicoPage } from './pages/publico/DiarioOficialDetalhePublicoPage';
import { VerificarDocumentoPublicoPage } from './pages/publico/VerificarDocumentoPublicoPage';
import { VerificarEntradaPage } from './pages/publico/VerificarEntradaPage';
import { PWAPrompts } from './components/PWAPrompts';
import { AcessibilidadeFlutuante } from './components/AcessibilidadeFlutuante';

export function App() {
  return (
    <AuthProvider>
      <PWAPrompts />
      <AcessibilidadeFlutuante />
      <Routes>
        {/* Publicas (sem login) */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/cadastro" element={<CadastroPage />} />
        <Route path="/recuperar-senha" element={<RecuperarSenhaPage />} />

        {/* Pos-login, sem exigencia de cadastro completo */}
        <Route path="/completar-cadastro" element={
          <RotaProtegida>
            <CompletarCadastroPage />
          </RotaProtegida>
        } />
        <Route path="/perfil" element={
          <RotaProtegida>
            <PerfilPage />
          </RotaProtegida>
        } />

        {/* Início — público (home pública sem login) ou painel do cidadão se logado */}
        <Route path="/" element={<InicioGate />} />

        {/* Canais de atendimento / telefones uteis: publica (item 2.50) */}
        <Route path="/canais" element={<CanaisAtendimentoPage />} />

        {/* Carta de Servicos: publica (sem login obrigatorio para listar/ver detalhe) */}
        <Route path="/servicos" element={<CartaServicosPage />} />
        <Route path="/servicos/detalhe/:id" element={<ServicoDetalhePage />} />

        <Route path="/solicitar/:assuntoId" element={
          <RotaProtegida exigirCadastroCompleto>
            <SolicitarPage />
          </RotaProtegida>
        } />

        <Route path="/minhas-solicitacoes" element={
          <RotaProtegida>
            <MinhasSolicitacoesPage />
          </RotaProtegida>
        } />

        <Route path="/participo" element={
          <RotaProtegida>
            <ProcessosParticipoPage />
          </RotaProtegida>
        } />

        <Route path="/fornecedor" element={
          <RotaProtegida>
            <FornecedorOrdensPage />
          </RotaProtegida>
        } />

        {/* Detalhe da OS — splat porque o numero contem barra (ex.: OS-0001/2026). */}
        <Route path="/fornecedor/*" element={
          <RotaProtegida>
            <FornecedorOrdemDetalhePage />
          </RotaProtegida>
        } />

        <Route path="/notificacoes" element={
          <RotaProtegida>
            <NotificacoesPage />
          </RotaProtegida>
        } />

        <Route path="/enquetes" element={
          <RotaProtegida>
            <EnquetesPage />
          </RotaProtegida>
        } />

        <Route path="/conselho" element={
          <RotaProtegida>
            <ConselhoPage />
          </RotaProtegida>
        } />

        <Route path="/solicitacao/*" element={
          <RotaProtegida>
            <SolicitacaoDetailPage />
          </RotaProtegida>
        } />

        {/* Ouvidoria — pode ser anônima (sem login) */}
        <Route path="/ouvidoria" element={<OuvidoriaPage />} />

        {/* e-SIC — exige login (LAI exige identificação) */}
        <Route path="/esic" element={
          <RotaProtegida exigirCadastroCompleto>
            <EsicAbrirPage />
          </RotaProtegida>
        } />
        <Route path="/esic/:numero/recorrer" element={
          <RotaProtegida>
            <EsicRecorrerPage />
          </RotaProtegida>
        } />

        {/* Recurso de Transito — exige login (CTB exige identificacao) */}
        <Route path="/recurso-transito" element={
          <RotaProtegida exigirCadastroCompleto>
            <RecursoTransitoAbrirPage />
          </RotaProtegida>
        } />
        <Route path="/recurso-transito/:numero/cetran" element={
          <RotaProtegida>
            <RecursoTransitoCetranPage />
          </RotaProtegida>
        } />

        {/* PSS — lista publica + detalhe publico + inscrever (auth) + minhas (auth) */}
        <Route path="/pss" element={<PssListPublicoPage />} />
        <Route path="/pss/:numero" element={<PssEditalDetalhePage />} />
        <Route path="/pss/:numero/inscrever" element={
          <RotaProtegida exigirCadastroCompleto>
            <PssInscreverPage />
          </RotaProtegida>
        } />
        <Route path="/minhas-inscricoes" element={
          <RotaProtegida>
            <PssMinhasInscricoesPage />
          </RotaProtegida>
        } />

        {/* Aprovacao de Projetos — submeter (auth+cadastro) */}
        <Route path="/aprovacao-projetos" element={
          <RotaProtegida exigirCadastroCompleto>
            <AprovacaoProjetosSubmeterPage />
          </RotaProtegida>
        } />

        {/* Públicas (sem login) */}
        <Route path="/protocolo/*" element={<AcompanharProtocoloPublicoPage />} />
        <Route path="/mapa" element={<MapaPublicoPage />} />
        <Route path="/ouvidoria/avaliar/:token" element={<OuvidoriaAvaliarPage />} />
        <Route path="/ouvidoria/mapa" element={<OuvidoriaMapaPage />} />
        <Route path="/transparencia/ouvidoria" element={<OuvidoriaIndicadoresPage />} />
        <Route path="/transparencia/esic" element={<EsicTransparenciaPage />} />
        <Route path="/transparencia/atos-oficiais" element={<AtosOficiaisPublicoPage />} />
        <Route path="/transparencia/atos-oficiais/:id" element={<AtoOficialDetalhePublicoPage />} />
        <Route path="/transparencia/protocolo-legislativo" element={<ProtocoloLegislativoPublicoPage />} />
        <Route path="/transparencia/protocolo-legislativo/:id" element={<ProtocoloLegislativoDetalhePublicoPage />} />

        <Route path="/zeladoria" element={<ZeladoriaAbrirPage />} />
        <Route path="/zeladoria/mapa" element={<ZeladoriaMapaPage />} />
        <Route path="/transparencia/zeladoria" element={<ZeladoriaIndicadoresPage />} />

        <Route path="/transparencia/diario-oficial" element={<DiarioOficialPublicoPage />} />
        <Route path="/transparencia/diario-oficial/:id" element={<DiarioOficialDetalhePublicoPage />} />

        {/* Verificacao publica de autenticidade (QR code dos PDFs) */}
        <Route path="/verificar" element={<VerificarEntradaPage />} />
        <Route path="/verificar/:codigo" element={<VerificarDocumentoPublicoPage />} />

        {/* Embed para iframe (sem layout) */}
        <Route path="/embed/servicos" element={<ServicosEmbedPage />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-slate-800 mb-2">404</h1>
        <p className="text-slate-600">Página não encontrada</p>
      </div>
    </div>
  );
}
